// extracted by mini-css-extract-plugin
export default {"wrap":"Label_wrap__VLX1W","label":"Label_label__kptc9","value":"Label_value__gcalY"};